module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1c6d2342a282759e4246bf6868e32c52.png";